import logo from './static/images/yle-logo.png';
import './static/css/common.css';
import { Auth } from 'aws-amplify';
import { signOut } from "./Auth";
import { useNavigate } from "react-router-dom";
import { Navbar, NavItem, Nav, NavbarBrand } from 'reactstrap';
import { Form, Input, Button } from 'reactstrap';

const Header = ({isAuthenticated, searchValue, setSearchValue}) => {
  const navigate = useNavigate();

  //console.log("isAuthenticated: " + isAuthenticated);

  const SignOut = async(event) => {
    try {
      await signOut();
      navigate("/");
    } catch (error) {
        console.log('error signing out', error);
    }
  }

  const doSearch = (event) => {
    event.preventDefault();
    const value = event.target.value!==undefined ? event.target.value : event.currentTarget?.elements?.search?.value;
    setSearchValue(value);
  }

  return (
    <>
    <Navbar>
        <NavbarBrand href="/">
          <img src={logo} alt="Yle" className="logo"/>
          <span className="title">Uudelleenohjaukset</span>
        </NavbarBrand>   
        { isAuthenticated === true &&        
        <Form onSubmit={doSearch}>
        <div className="d-flex">
          <Input value={searchValue} onChange={e => doSearch(e)} className="m-2" type="text" name="search" id="search" />
          <Button className="m-2" type="submit" color="primary">Etsi</Button> 
        </div>   
        </Form>
        }
        { isAuthenticated === true &&
        <Nav className="p-5">
        <NavItem>
          <Button type="submit" color="secondary" onClick={SignOut}>Kirjaudu ulos</Button>
        </NavItem>
        </Nav>        
        }
        { !isAuthenticated &&
        <Nav className="p-5">
        <NavItem>
          <Button type="submit" color="primary" onClick={() => Auth.federatedSignIn({provider: "EntraSAML" })}>Kirjaudu sisään</Button>
        </NavItem>
        </Nav>        
        }
    </Navbar>
    </>
  );
}
export default Header;
